<template>
  <div>
    <img
      class="img_box"
      :class="{ img_position: this.$route.params.id - 1 == 2 }"
      :src="storyData[this.$route.params.id - 1].imgURl"
      alt=""
    />
    <div class="story_box">
      <div class="story_title">
        {{ storyData[this.$route.params.id - 1].title }}
      </div>
      <div class="story_content">
        <div
          v-for="(item, index) in storyData[this.$route.params.id - 1].content"
          class="paragraph"
          :class="{
            double_p: index % 2 > 0,
            mobile_p: $isMobile,
            single_mobile_p: $isMobile && index % 2 == 0,
            double_mobile_p: $isMobile && index % 2 > 0,
          }"
        >
          <img
            v-if="!($isMobile && index % 2 > 0)"
            class="p_icon"
            :src="
              index % 2 > 0
                ? require('../assets/images/double.png')
                : require('../assets/images/single.png')
            "
            alt=""
          />
          <img
            v-else
            class="mobile_icon"
            src="../assets/images/right_icon.png"
            alt=""
          />
          <div v-html="item"></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'EmployeeStory',
  data() {
    return {
      storyData: [
        {
          imgURl: require('../assets/images/gushi_pic3.png'),
          title: '“不设限”，职场小白变身优秀运营——产品运营部缑智昊',
          content: [
            '缑同学，零壹比特在你心目中是一家什么样的公司呢？',
            '在知乎上其实很少刷到关于零壹比特的信息，今天我也特别想介绍下这家小而美的互联网公司。初次听到零壹比特，可能会以为我们是一家区块链公司，其实我们的主要赛道是出海社交。',
            '那为什么叫零壹比特呢？',
            '取名零壹比特，是因为在计算机语言中，01是计算机唯一能识别的两个字符，比特bit则是信息处理的最小单位，寓意企业像计算机一样从01开始学习，逐步演化为超智能体。',
            '零壹比特目前主要运营的产品有哪些呢？',
            '我所在的海外项目部主要负责运营一款出海泛娱乐社交产品，作为较早踏上出海之路的产品，长期占领南亚、东南亚、中东地区社交产品畅销榜榜首。',
            '好的，可以和我们分享下在零壹比特的新人体验如何吗？',
            '新人体验啊，当然非常棒呀，不然我怎么会呆了一年以上呢。（此处应有掌声。。）',
            '那在新人体验过程中，你比较喜欢哪部分环节呢？',
            'leader和mentor对新人带教的环节吧，我觉得这个对新人，特别是应届生来说是特别需要的，也是特别有用的。比如可以帮助新人更快地融入团队，解决一些工作中遇到的难题，当然也可以直接向上提出要资源的要求哈哈。',
            '现在很多同学其实更倾向于大厂的机会，那你觉得相比大厂，零壹比特有哪些优势吗？',
            '怎么说呢，大厂的优势在于严丝合缝的组织形式和长久以来沉淀的成熟方法论，零壹比特的优势则在于不受限制、野蛮生长的开放环境。如果你是一个具有自驱力和学习力的人，我非常推荐你选择零壹比特，开拓一片属于自己的天地。公司有不少技术和产品大牛，能力强人也很nice，不论你是刚入职的技术还是运营，只要有问题，都可以直接去工位找他们答疑。如果你有灵光乍现的想法，准备好你的ppt，约大家在会议室碰一下，说不定你的想法就可以在未来某一天落地。',
            '那加入零壹比特后，新人有没有能快速“奔现”的机会呢？',
            '这个。。只要你有能力，只有你愿意，一切皆有可能吧哈哈。。其实公司很重视新人的能力展示，在我们这叫“亮相”。leader会在你入职后主动帮你争取展示机会，我有幸在还未转正时在全公司范围做了会员体系的竞品分析，一年后还参与了产品会员体系的落地工作。在这里，只要你能抓住机会，就能获得职业生涯的攀升。',
            '听起来确实是一家很nice的公司哦，那你觉得在零壹比特会不会有很大的压力？',
            '想要成为优秀的人，那压力肯定多少都会有的。但零壹比特不会特别为员工设置工作指标， 在多数互联网公司，员工都会担负kpi或是okr指标。在零壹比特，只有针对整个团队提出的收入、用户量等指标，这意味着每个人可以真正全情投入手头的工作，而不用为个人kpi犯愁。',
            '零壹比特的“秃头小哥哥”多吗，哈哈开个玩笑，就是想了解下有没有什么996的加班文化吗？',
            '我们不提倡无必要的加班，更没有到点不能走的隐性加班文化。只要保证手头工作的按时交付，下班后的8个小时完全可以自由支配。我一般会利用闲暇时间去公司健身房健身或者参加每周的泡会活动， 提升自己的同时拿到泡会补贴，一举两得。',
            '聊了这么多，很想了解下零壹比特的文化是怎么样的呢？',
            '我觉得首要提倡共赢文化，比如疫情时期，海外项目为上万海外女用户解决了就业问题，以用户反馈指导产品迭代，在提升产品体验同时扶植优质用户，达成产品与用户的共赢。此外，公司还强调企业与员工的共赢，为员工提供可观的薪资福利和成长机会，这点放在最后说。零壹比特还提倡精英文化，拒绝培养岗位的螺丝钉，鼓励每位员工在专精的领域之外寻求更多成长机会。我刚入职在做比较基础的客服和审核工作，一年后已经可以独立负责小的产品模块和内容风控业务，这样的成长机会在很多大厂也很难遇到。',
            '最后想帮大家了解下最想了解的问题，你猜是什么呢哈哈哈。',
            '那肯定是薪酬福利啊！这块我觉得真的非常非常OK！零壹比特一向求贤若渴，公司体量虽离大厂还有段距离，但对优秀人才开价绝对不输大厂。 薪资这么给力，年终奖也拖不了后腿。之前提过零壹比特最重要的kpi是项目的收入，如果成功完成年度指标，会有可观的年终奖发放给各部门进行分配。我有幸在海外项目蓬勃发展阶段加入零壹比特，去年拿到的年终奖放到现在可以买很多部iPhone14pro了。对于一个当时参加工作不久的应届生来说，真香！ 除开丰厚的薪资报酬，还有一年两次的大型团建活动和每季度一次的小型团建活动可以参加。大型团建一般是周年庆和年会，小型团建则是登山、轰趴等户外活动。每年周年庆和年会都会有抽奖活动，一等奖可以抽到新款华为手机或是电脑，不自用的话挂咸鱼又是一笔不小的收入。',
          ],
        },
        {
          imgURl: require('../assets/images/gushi_2_new.jpeg'),
          title: '从美院毕业到游戏设计——以热爱开启职场新篇章',
          content: [
            '松林你看着更壮了，最近健身成果斐然呀，听说你最近还在担任很多小伙伴的 健身教练 ？',
            '谢谢夸奖！其实能有这成果，一半得靠公司的健身房福利——去年刚入职时发现有这个配置，真的特别惊喜，不用跑外面健身房省了很多时间，我平时会利用下班后的1小时来练，正好公司工作日晚上会提供免费的晚餐，可以练前补充能量，时间灵活又方便。<br> 另一半就是靠坚持了，我给自己定了每周4次的固定计划，慢慢就养成了习惯。后来身边同事看到变化，总来问动作细节或饮食建议，我就干脆拉着大家一起练，算不上正经教练，就是搭伴监督、分享点经验。现在不光身体壮了，和同事们的关系也更近，工作时精力也更足，算是意外的收获吧。',
            '也有了解到你之前是一位老师，从 “老师” 到 “游戏设计”，身份的转变让你感受最深的是什么？',
            '其实刚开始从老师转做游戏设计时，我还挺忐忑的 —— 以前是对着学生输出知识，现在得和团队一起琢磨游戏的视觉表现和创意，完全另一种创作逻辑。但入职之后，公司的氛围真的帮了我很多。刚进来时，带我的前辈没让我慌着赶工，反而先拉着我看项目美术规范，改我初稿时会蹲下来一起调颜色，有不懂的地方问过去，大家都会把经验掰开揉碎讲；团队脑暴也从不 “论资排辈”，哪怕我提的想法不成熟，也会被认真讨论。这种不压抑、愿意带新人的环境，让我慢慢放下了 “怕做错” 的顾虑，现在也能独立跟进部分设计了。要是没有这种包容的氛围，我可能要花更久才能适应这个转变。',
            '现在的工作中，你觉得最有挑战性的部分是什么？有没有让你觉得 “很有成就感” 的小进步？',
            '说实话，最有挑战的是从“被动接需求”到“主动抠细节”的转变——最开始跟着团队做项目的时候，由于没有太多工作经验，导致不能够很好的理解产品逻辑和项目需求，没法推动项目优化，因此总是被动地等待同事们的建议与帮助。但在充分理解公司产品和工作流程后，自己目前已经能够针对具体的需求主动进行优化和补充，工作效率提高了很多，并在过程中学习了许多新的知识与技能，帮助团队将产品做的更好。<br>这期间让我感到最后成就感的一件事是就是来自用户的正反馈，记得有个参与了很久的项目刚上线时，偶然间看在弹幕区看到有用户发了句“NICE GAME”，虽然以现在的眼光看当时的版本还有许多不足，但是我从这句话中获得了很大的能量，让我能够在后续的版本迭代中更有动力，希望有更多的用户能够使用我们的产品。',
            '你来公司也有一年的时间啦，这一年最主要的感受有哪些？',
            '现在回头看这一年，最真切的感受就是自己的成长，包括个人能力的成长，和团队协作的成长。<br>初入公司时，我对项目流程和行业标准还不够熟悉，但在导师和同事们的耐心帮助下，我很快融入了节奏。感恩于公司同事们给予的信任与机会，让我能够不断试错、学习，并在项目中承担更重要的角色。无论是三维渲染还是二维动效，我的专业技能和审美都在实战中得到了扎实的提升。<br>公司推崇的“精英”文化，并非单打独斗，而是追求极致的专业精神。我与程序、产品同事紧密沟通，为了最终的产品质量，反复打磨细节。这个过程让我深刻理解到，个人的卓越必须融入团队的协作，才能真正创造价值。而最大的收获，是体会到“共赢”的真正含义。项目的成功是团队所有人的成功，个人的成长也与公司的发展同频共振。感谢公司提供这样优秀的平台，未来我将继续努力，以更高的专业水准为团队和公司创造更多价值。',
          ],
        },
        {
          imgURl: require('../assets/images/gushi_3_new.jpeg'),
          title: '从技术骨干到管理核心——“公司给机会，个人敢突破” 的双向奔赴',
          content: [
            '昇哥你8年前加入公司时是基层技术人员，现在已经成长为管理层，最初是什么契机让你从 “写代码” 转向 “带团队”？',
            '刚加入公司时，可能是平时对待工作认真负责的态度得到了领导的认可，第二年公司就给机会让我从基层开发成为了开发组长。后面公司要做一款教育类应用，秉承公司担当的价值观，在内部选人期间我毛遂自荐并非常荣幸地获得了这个带项目的机会，真正意义上让我从 “写代码” 转向了 “带团队”。',
            '你参与过的项目中，有没有哪个项目让你觉得 “转型管理后，看待问题的视角完全不一样了”？',
            '从第一个项目开始，我前后已经有过三个项目的经历。现在回过头来看，前两个项目在项目经验上还是有所欠缺的，虽然激情满满、版本效率非常高但是缺乏全局管理能力。到目前的游戏项目，才算是看待问题的视角完全不一样了。不再只盯着版本开发进度，而更看重项目节奏与人员管理，根据产品方向及近期数据目标推进部门工作进展。',
            '公司一直在持续推进多个新项目探索，你觉得公司愿意 “投入资源做探索” 的核心原因是什么？',
            '公司愿意投入资源做探索，我认为核心原因有两点。第一点也是比较重要的一点就是面向长期可持续发展，行业变化快，探索创新让我们有更多机会，是业绩增长曲线的第二引擎；第二点就是人才培养，公司愿意给员工搭建平台，给到项目资源帮助员工成长，这对于员工来讲是一笔不小的财富。',
            '对于刚加入公司的员工，尤其是想在技术或管理上长期成长的人，有没有什么想对他们说的话？',
            '心怀感恩的心，在自己的岗位上精益求精，目标自取、节奏自管、复盘自检，敢于承担敢于挑战。相信共赢，时刻以精英的标准要求自己。先让自己成为可靠的工程师，然后再争取成为可信赖的管理者。',
          ],
        },
      ],
    }
  },
  mounted() {
    console.log(this.$route.params.id)
  },
}
</script>

<style lang="less" scoped>
.img_box {
  width: 100%;
  height: 70vh;
  object-fit: cover;
  object-position: center;

  &.img_position {
    object-position: 0 -1.2rem;
  }
  @media (max-width: 700px) {
    height: 1.8rem;
    &.img_position {
      object-position: 0 0;
    }
  }
}
.story_box {
  @media (max-width: 700px) {
    padding: 0.12rem 0.24rem;
  }
  padding: 1rem 2.8rem;
}
.story_title {
  @media (max-width: 700px) {
    font-size: 0.14rem;
    margin-bottom: 0.2rem;
  }
  font-family: 'AlimamaShuHeiTi-Bold';
  font-size: 0.3rem;
  color: #183266;
  margin-bottom: 0.4rem;
}
.story_content {
  @media (max-width: 700px) {
    font-size: 0.14rem;
    line-height: 0.2rem;
  }
  font-size: 0.18rem;
  font-weight: 400;
  color: #79849b;
  line-height: 0.3rem;
}
.paragraph {
  @media (max-width: 700px) {
    margin-bottom: 0.12rem;
    padding: 0.1rem;
  }
  width: max-content;
  max-width: 100%;
  padding: 0.2rem;
  color: #79849b;
  background: rgba(14, 86, 228, 0.05);
  border-radius: 0 12px 12px 12px;
  box-sizing: border-box;
  position: relative;
  margin-bottom: 0.18rem;
  text-align: justify;
}
.double_p {
  background: rgba(14, 86, 228, 0.15);
}
.p_icon {
  position: absolute;
  top: 0;
  left: -0.1rem;
  width: 0.11rem;
  height: 0.15rem;
}
.mobile_icon {
  position: absolute;
  top: 0;
  right: -0.11rem;
  width: 0.11rem;
  height: 0.15rem;
}
.mobile_p {
  width: 78.93%;
}
.single_mobile_p {
  float: left;
}
.double_mobile_p {
  float: right;
  border-radius: 12px 0 12px 12px;
}
</style>
